// Small shared UI atoms for the Careers form.
export const RequiredMark = () => (
  <span className="text-[hsl(var(--primary))] ml-0.5" aria-label="required">*</span>
);

export function YesNo({ value, onChange, testId }) {
  return (
    <div className="flex gap-2">
      {[["Yes", true], ["No", false]].map(([lbl, v]) => (
        <button
          type="button"
          key={lbl}
          onClick={() => onChange(v)}
          className={`px-4 h-9 rounded-full text-sm font-medium border transition-colors ${
            value === v
              ? "bg-[hsl(var(--primary))] text-white border-[hsl(var(--primary))]"
              : "bg-white border-neutral-200 hover:border-neutral-400"
          }`}
          data-testid={`${testId}-${String(v)}`}
        >{lbl}</button>
      ))}
    </div>
  );
}

export function sectionBorder(hasMissing) {
  return hasMissing ? "border-amber-400" : "border-neutral-200/70";
}
